<template>
  <div class="buttonMain" :style="`border-radius: ${props.radius}px;border:${borderStyle != null ? borderStyle : null}; background:${color != null ? color : 'white'};
  padding:${paddingTop}; pointer-events: ${isDisable ? 'none' : 'auto'}; min-height: ${minHeight}px ; opacity:${isDisable ? .4:1 };`" v-if="!isHidden">
    <el-popover
        ref="popoverRef"
        width="auto"
        trigger="hover"
        placement="top"
        popper-class="custom-popover"
        v-if="hoverTitle && clickMouse"
    >
      <template #reference>
        <div class="buttonView" @click="onPress">
          <i v-if="iconFont && iconType == 0" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-right: 10px; color: ${iconFontColor};`" />
          <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 0" :width="imageSize" :height="imageSize">
          <div class="buttonTitle" v-if="title != null" :style="`color: ${textColor != null ? textColor : 'white'}; margin-left: ${icon != null ? '4px' : '0'}; font-size: ${customFontSize}; font-weight: ${ isBold ? 'bold' : 'normal'}`">
            {{title}}
          </div>
          <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 1" style="margin-left: 10px;" :width="imageSize" :height="imageSize">
          <i v-if="iconFont && iconType == 1" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-left: 10px; color: ${iconFontColor};`" />
        </div>
      </template>
      <div class="popoverDiv" style="width: 248px">
        <div class="title">{{hoverTitle}}</div>
      </div>
    </el-popover>
    <el-popover
        ref="popoverRef"
        width="auto"
        trigger="hover"
        placement="top"
        popper-class="custom-popover"
        v-if="hoverTitle && !clickMouse"
    >
      <template #reference>
        <div class="buttonView">
          <i v-if="iconFont && iconType == 0" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-right: 10px; color: ${iconFontColor};`" />
          <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 0" :width="imageSize" :height="imageSize">
          <div class="buttonTitle" v-if="title != null" :style="`color: ${textColor != null ? textColor : 'white'}; margin-left: ${icon != null ? '4px' : '0'}; font-size: ${customFontSize}; font-weight: ${ isBold ? 'bold' : 'normal'}`">
            {{title}}
          </div>
          <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 1" style="margin-left: 10px;" :width="imageSize" :height="imageSize">
          <i v-if="iconFont && iconType == 1" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-left: 10px; color: ${iconFontColor};`" />
        </div>
      </template>
      <div class="popoverDiv" style="width: 248px">
        <div class="title">{{hoverTitle}}</div>
      </div>
    </el-popover>
    <div class="buttonView" v-if="!hoverTitle && clickMouse" @click="onPress">
      <i v-if="iconFont && iconType == 0" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-right: 10px; color: ${iconFontColor};`" />
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 0" :width="imageSize" :height="imageSize">
      <div class="buttonTitle" v-if="title != null" :style="`color: ${textColor != null ? textColor : 'white'}; margin-left: ${icon != null ? '4px' : '0'}; font-size: ${customFontSize}; font-weight: ${ isBold ? 'bold' : 'normal'}`">
        {{title}}
      </div>
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 1" style="margin-left: 10px;" :width="imageSize" :height="imageSize">
      <i v-if="iconFont && iconType == 1" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-left: 10px; color: ${iconFontColor};`" />
    </div>

    <div class="buttonView" v-if="!hoverTitle && !clickMouse">
      <i v-if="iconFont && iconType == 0" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-right: 10px; color: ${iconFontColor};`" />
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 0" :width="imageSize" :height="imageSize">
      <div class="buttonTitle" v-if="title != null" :style="`color: ${textColor != null ? textColor : 'white'}; margin-left: ${icon != null ? '4px' : '0'}; font-size: ${customFontSize}; font-weight: ${ isBold ? 'bold' : 'normal'}`">
        {{title}}
      </div>
      <img :src="select ? selectIcon : icon" v-if="icon != null && iconType == 1" style="margin-left: 10px;" :width="imageSize" :height="imageSize">
      <i v-if="iconFont && iconType == 1" :class="`iconfont ${iconFont}`" :style="`font-size: 16px; line-height: 16px; margin-left: 10px; color: ${iconFontColor};`" />
    </div>
  </div>
</template>

<script setup lang="ts">

import {onMounted, ref, defineExpose, defineEmits} from 'vue'
defineExpose({ onClear })
let call = defineEmits(["ButtonClick"])

let select = ref(false)

const props = defineProps({
  iconFont: {
    type: String,
  },
  iconFontColor: {
    type: String
  },
  icon: {
    type: String,
  },
  title: {
    type: String,
  },
  color: {
    type: String,
  },
  textColor: {
    type: String,
  },
  borderStyle: {
    type: String,
  },
  selectIcon: {
    type: String,
  },
  initSelect: {
    type: Boolean,
  },
  onClick: {
    type: Function,
    default: null
  },
  isHidden: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
  },
  iconType: {
    type: Number,
    default: 0
  },
  paddingTop: {
    type: String,
    default: "10px 30px"
  },
  customFontSize: {
    type: String,
    default: "20px"
  },
  isDisable: {
    type: Boolean,
    default: false
  },
  isBold: {
    type: Boolean,
    default: false
  },
  radius: {
    type: Number,
    default: 0
  },
  imageSize: {
    type: String,
    default: "24px"
  },
  hoverTitle: {
    type: String,
  },
  minHeight: {
    type: Number,
    default: 40
  },
  clickMouse: {
    type: Boolean,
    default: true
  }
})

function onPress() {
  if (props.isDisable) {
    return
  }
  if (props.selectIcon) {
    select.value = !select.value
  }
  call("ButtonClick",props.index)
  if (props.onClick) {
    props.onClick()
  }
}

function onClear() {
  console.log("onClear")
  select.value = false
}

onMounted(()=>{
  select.value = props.initSelect
})

</script>

<style scoped lang="scss">
.buttonMain {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 4px !important;
}

.buttonView {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  
  &:hover{
    opacity: 0.6;
    cursor: pointer;
  }
}

.buttonTitle {
  font-size: 20px;
  white-space: nowrap;
  line-height: 20px;
  text-align: center;
  white-space: pre-wrap !important;
  /* 保留空格和换行符，允许自动换行 */
  word-wrap: break-word !important;
  /* 允许长单词或 URL 地址换行到下一行 */
  overflow-wrap: break-word !important;
}

</style>
